import { ArrowRight, Clock, MessageSquare, Settings2, Users } from 'lucide-react';
import { Badge } from '../../../../components/ui/badge';
import { Button } from '../../../../components/ui/button';
import { Switch } from '../../../../components/ui/switch';
import type { WorkflowStatus, WorkflowTransition } from '@leal-crm/shared';
import { DIALOG_TYPE_LABELS } from '../constants';

interface TransitionRowProps {
  transition: WorkflowTransition;
  fromStatus: WorkflowStatus;
  toStatus: WorkflowStatus;
  onEdit: () => void;
  onToggle: () => void;
  isUpdating: boolean;
}

export function TransitionRow({ transition, fromStatus, toStatus, onEdit, onToggle, isUpdating }: TransitionRowProps) {
  return (
    <div className="flex flex-col gap-3 p-3 rounded-lg border bg-card sm:flex-row sm:items-center sm:justify-between">
      <div className="flex min-w-0 flex-wrap items-center gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: fromStatus.color }}
          />
          <span className="font-medium text-sm truncate">{fromStatus.name}</span>
        </div>
        <ArrowRight className="h-4 w-4 text-muted-foreground" />
        <div className="flex min-w-0 items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: toStatus.color }}
          />
          <span className="font-medium text-sm truncate">{toStatus.name}</span>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2 sm:justify-end">
        <Badge variant="outline" className="text-[10px] gap-1">
          <MessageSquare className="h-3 w-3" />
          {DIALOG_TYPE_LABELS[transition.dialogType]}
        </Badge>

        {(transition.minTimeInStatusMinutes || transition.maxTimeInStatusMinutes) && (
          <Badge variant="secondary" className="text-[10px] gap-1">
            <Clock className="h-3 w-3" />
            {transition.minTimeInStatusMinutes && `>=${transition.minTimeInStatusMinutes}min`}
            {transition.minTimeInStatusMinutes && transition.maxTimeInStatusMinutes && ' · '}
            {transition.maxTimeInStatusMinutes && `<=${transition.maxTimeInStatusMinutes}min`}
          </Badge>
        )}

        {transition.allowedRoles && transition.allowedRoles.length > 0 && (
          <Badge variant="secondary" className="text-[10px] gap-1">
            <Users className="h-3 w-3" />
            {transition.allowedRoles.length} roles
          </Badge>
        )}

        <Switch checked={transition.isEnabled} onCheckedChange={onToggle} disabled={isUpdating} />

        <Button variant="ghost" size="sm" onClick={onEdit} disabled={isUpdating}>
          <Settings2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
